import { freshModal } from "../freshModal";
import React, { useState } from "react";
import Modal from "./Modal";

const PlacementContractModalFormSession = ({
  isOpen,
  onClose,
  onSave,
  candidateId,
}) => {
  const [formData, setFormData] = useState({
    clientName: "",
    contractType: "cdi",
    jobTitle: "",
    startDate: "",
    feePercentage: "20",
    salary: "",
    guaranteePeriod: "3",
    notes: "",
    candidateId,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Créer un contrat de placement"
      className="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="clientName"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Entreprise cliente
            </label>
            <input
              type="text"
              id="clientName"
              name="clientName"
              required
              value={formData.clientName}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              htmlFor="contractType"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Type de contrat
            </label>
            <select
              id="contractType"
              name="contractType"
              required
              value={formData.contractType}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="cdi">CDI</option>
              <option value="cdd">CDD</option>
              <option value="partiel">Temps partiel</option>
            </select>
          </div>
        </div>

        <div>
          <label
            htmlFor="jobTitle"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Intitulé du poste
          </label>
          <input
            type="text"
            id="jobTitle"
            name="jobTitle"
            required
            value={formData.jobTitle}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="startDate"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Date de début
            </label>
            <input lang="fr-FR"
              type="date"
              id="startDate"
              name="startDate"
              required
              value={formData.startDate}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              htmlFor="feePercentage"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Commission (%)
            </label>
            <input
              type="number"
              id="feePercentage"
              name="feePercentage"
              required
              value={formData.feePercentage}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="salary"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Salaire annuel brut (€)
            </label>
            <input
              type="number"
              id="salary"
              name="salary"
              required
              value={formData.salary}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              htmlFor="guaranteePeriod"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Période de garantie (mois)
            </label>
            <input
              type="number"
              id="guaranteePeriod"
              name="guaranteePeriod"
              required
              value={formData.guaranteePeriod}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="notes"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Notes complémentaires
          </label>
          <textarea
            id="notes"
            name="notes"
            rows={3}
            value={formData.notes}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Créer le contrat
          </button>
        </div>
      </form>
    </Modal>
  );
};

export const PlacementContractModal = freshModal(PlacementContractModalFormSession, "isOpen");
